import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "section-cart" }
const _hoisted_2 = {
  key: 0,
  class: "section-cart__empty"
}
const _hoisted_3 = {
  key: 1,
  class: "section-cart__list"
}
const _hoisted_4 = { class: "list-cart" }
const _hoisted_5 = { class: "section_cart__info" }
const _hoisted_6 = { class: "section_cart__info__buttons" }

import { ref } from "vue";
import CardProductCart from "./components/CardProductCart.vue";
import { useCartShoppingStore } from "@/store/cartshopping";


export default /*@__PURE__*/_defineComponent({
  __name: 'CartView',
  setup(__props) {

const cartShop = useCartShoppingStore();
const infoclient = ref({
  type_document: "",
  number_document: "",
  text_document: "",
  email: "",
});
const messageIncomplete = ref({
  number_document: "",
});

function validateFormInfo() {
  if (
    infoclient.value.type_document === "0" ||
    infoclient.value.number_document === "" ||
    infoclient.value.email === ""
  ) {
    return false;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(infoclient.value.email)) {
    //console.log('Debe ingresar un correo electrónico válido');
    return false;
  }
  return true;
}

function sendWhatsApp() {
  if (!validateFormInfo()) {
    alert(
      "Por favor, completa todos los campos correctamente antes de enviar la cotizacion."
    );
    return;
  }

  let message = `Hola, me gustaría cotizar los siguientes productos:\n\n`;
  cartShop.cart.forEach((product) => {
    message += `- ${product.name_product} (${product.quantity} unidades)\n`;
  });
  message += `\nMis datos son:\nTipo de documento: ${infoclient.value.type_document}\nNúmero de documento: ${infoclient.value.number_document}\nCorreo electrónico: ${infoclient.value.email}`;

  const whatsappUrl = `https://api.whatsapp.com/send?phone=51998247832&text=${encodeURIComponent(
    message
  )}`;
  window.open(whatsappUrl, "_blank");
  //console.log('Enviar por WhatsApp', infoclient.value);
}

function sendEmail() {
  if (!validateFormInfo()) {
    alert(
      "Por favor, completa todos los campos correctamente antes de enviar la cotizacion."
    );
    return;
  }

  const subject = "Solicitud de Cotización";
  let body = `Hola, me gustaría cotizar los siguientes productos:\n\n`;
  cartShop.cart.forEach((product) => {
    body += `- ${product.name_product} (${product.quantity} unidades)\n`;
  });
  body += `\nMis datos son:\nTipo de documento: ${infoclient.value.type_document}\nNúmero de documento: ${infoclient.value.number_document}\nCorreo electrónico: ${infoclient.value.email}`;

  const mailtoUrl = `mailto:Johancanchary@gmail.com?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoUrl;
}

async function getInfo() {
  if (infoclient.value.type_document === "dni") {
    // Lógica para obtener información del DNI
    // Aquí puedes hacer la llamada a la API para obtener la información del DNI
    try {
      const response = await fetch(
        `https://miapi.cloud/v1/dni/${infoclient.value.number_document}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxMjQsImV4cCI6MTc1MjQ0MjY5M30.pS1-aDsdostE5-GpyLs_WPhOSQ98-5_RJzQpVD-9b7o",
          },
        }
      );
      const data = await response.json();
      infoclient.value.text_document = `${data.datos.ape_paterno} ${data.datos.ape_materno} ${data.datos.nombres}`;
    } catch (error) {
      infoclient.value.text_document = "";
      //alert('No se pudo obtener la información del DNI. Por favor, verifica el número ingresado.');
      messageIncomplete.value.number_document =
        " No se pudo obtener el DNI; verifica el número.";
    }
  } else if (infoclient.value.type_document === "ruc") {
    // Lógica para obtener información del RUC
    // Aquí puedes hacer la llamada a la API para obtener la información del RUC
    try {
      const response = await fetch(
        `https://miapi.cloud/v1/ruc/det/${infoclient.value.number_document}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxMjQsImV4cCI6MTc1MjQ0MjY5M30.pS1-aDsdostE5-GpyLs_WPhOSQ98-5_RJzQpVD-9b7o",
          },
        }
      );
      const data = await response.json();
      infoclient.value.text_document = `${data.datos.razon_social}`;
    } catch (error) {
      infoclient.value.text_document = "";
      //alert('No se pudo obtener la información del RUC. Por favor, verifica el número ingresado.');
      messageIncomplete.value.number_document =
        "No se pudo obtener el RUC; verifica el número.";
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("h2", null, "Carrito de Compra", -1)),
    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
    (_unref(cartShop).cart.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "Tu carrito está vacío", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
          _createVNode(_component_router_link, {
            to: "/productos",
            class: "button"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Agregar productos", -1)
            ]))]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartShop).cart, (product, id) => {
              return (_openBlock(), _createBlock(CardProductCart, {
                key: id,
                product: product
              }, null, 8, ["product"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Ingresa tu informacion", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _cache[11] || (_cache[11] = _createTextVNode(" Seleccionar tipo de documento: ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((infoclient.value.type_document) = $event))
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("option", { value: "0" }, "Seleccione tipo de documeto", -1),
                _createElementVNode("option", { value: "dni" }, "DNI", -1),
                _createElementVNode("option", { value: "ruc" }, "RUC", -1)
              ]))], 512), [
                [_vModelSelect, infoclient.value.type_document]
              ]),
              (infoclient.value.type_document != '0')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "text",
                    placeholder: "Ingre el numero de documento",
                    class: "input-document",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((infoclient.value.number_document) = $event))
                  }, null, 512)), [
                    [_vModelText, infoclient.value.number_document]
                  ])
                : _createCommentVNode("", true),
              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                placeholder: "Correo electronico",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((infoclient.value.email) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, infoclient.value.email]
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "button-whatsapp",
                  onClick: _cache[3] || (_cache[3] = () => sendWhatsApp())
                }, " Cotizar por WhatsApp "),
                _createElementVNode("button", {
                  class: "button-email",
                  onClick: _cache[4] || (_cache[4] = () => sendEmail())
                }, " Cotizar por Correo ")
              ])
            ], 32)
          ])
        ]))
  ]))
}
}

})